import { useState, createContext } from 'react';

const initialValue = {
    customerData: null,
    setCustomerData: () => {},
    settings: null,
    setSettings: () => {},
    videoPaused: false,
    setVideoPaused: () => {},
    seconds: 0,
    setSeconds: () => {},
    videoEnded: false,
    setVideoEnded: () => {},
    videoTime: null,
    setVideoTime: () => {},
    player: null,
    setPlayer: () => {},
    hideControls: [],
    setHideControls: () => {},
};

export const StoreContext = createContext(initialValue);

const StoreProvider = ({children}) => {
    const [customerData, setCustomerData] = useState(null);
    const [settings, setSettings] = useState(null);
    const [videoPaused, setVideoPaused] = useState(false);
    const [seconds, setSeconds] = useState(0);
    const [videoEnded, setVideoEnded] = useState(false);
    const [videoTime, setVideoTime] = useState(null);
    const [player, setPlayer] = useState(null);
    const [hideControls, setHideControls] = useState([]);

    const store = {
        customerData,
        setCustomerData,
        settings,
        setSettings,
        videoPaused,
        setVideoPaused,
        seconds,
        setSeconds,
        videoEnded,
        setVideoEnded,
        videoTime,
        setVideoTime,
        player,
        setPlayer,
        hideControls,
        setHideControls,
    };

    return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
}

export default StoreProvider;
